import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FiChild } from '@fscd-intake/entities';
import { FormBuilder, Validators } from '@angular/forms';
import { D3ModalDialogComponent } from '@d3/ui/shared-components';

@Component({
  standalone: false,
  selector: 'fi-start-app-modal',
  templateUrl: './start-app-modal.component.html',
  styleUrls: ['./start-app-modal.component.scss'],
})
export class StartAppModalComponent implements OnInit {
  @Input() showModal: EventEmitter<boolean>;
  @Output() startNewApp = new EventEmitter<FiChild>();

  @ViewChild('startAppModal') startAppModalRef: D3ModalDialogComponent;

  formGroup = this.fb.group({
    firstName: ['', Validators.required],
    middleName: [''],
    lastName: ['', Validators.required],
  });

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.showModal.subscribe((shouldShow) => {
      if (shouldShow) this.startAppModalRef.openModal('information', null, true);
      else this.startAppModalRef.closeModal();
    });
  }

  onModalClose() {
    this.formGroup.reset();
  }

  onAddChildContinue() {
    const newChild = new FiChild();
    newChild.firstName = this.formGroup.controls.firstName.value?.trim() ?? '';
    newChild.middleName = this.formGroup.controls.middleName.value?.trim() ?? '';
    newChild.lastName = this.formGroup.controls.lastName.value?.trim() ?? '';
    if (!newChild.firstName || !newChild.lastName) {
      this.formGroup.controls.firstName.markAsTouched();
      this.formGroup.controls.lastName.markAsTouched();
      return;
    }

    this.startAppModalRef.closeModal();
    this.startNewApp.emit(newChild);
  }

  onAddChildCancel() {
    this.startAppModalRef.closeModal();
  }
}
